import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import {
  GridColumn,
  GridRow,
  GridContainer,
  Toastr,
  Modal,
} from "arv-reactcomponents";
import BodyOverlay from "../BodyOverlay";
import OrderSummary from "./OrderSummary";
import PricingOverview from "../PricingOverview";
import ConsignmentWrapper from "./ConsignmentWrapper";
import OrderDetailsFooter from "./OrderDetailsFooter";
import { redirect } from "../../utils";
import Returns from "../ReturnComponent";
import { PRICINGOVERVIEW, ORDERDETAILS } from "npmlinks-constants";
import { GTM } from "../../analytics";
import Event from "../../analytics/eventFactory";

const { ORDER_DETAILS, ORDER_DETAILS_MESSAGES } = ORDERDETAILS;
const { TEXT, TOTAL } = PRICINGOVERVIEW;

@inject("OrdersStore")
@observer
class OrderDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderDetails: {},
      isOpen: false,
      itemId: "",
      addressId: "",
      orderId: "",
      returnType: "",
      childClassName: "",
    };
    this.activateReturns = this.activateReturns.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.classNameSelector = this.classNameSelector.bind(this);
    this.getOrderDetails = this.getOrderDetails.bind(this);
  }

  componentDidMount() {
    this.getOrderDetails();
  }
  get pricingDetails() {
    const { orderDetails } = this.state;
    const { totalPricingDetails } = orderDetails;
    if (totalPricingDetails) {
      const {
        totalDiscountDetails,
        subTotal: subtotal,
        totalTax: tax,
        shippingCharge: shippingCost,
        totalAmountWithShipping: total,
      } = totalPricingDetails;
      const { totalDiscount: discount } = totalDiscountDetails;
      const pricingData = {
        [TEXT.subtotal]: subtotal,
        [TEXT.discounts]: discount,
        [TEXT.tax]: tax,
        [TEXT.shippingCost]: shippingCost,
        [TOTAL.total]: total,
      };
      return pricingData;
    }
    return {};
  }
  getOrderDetails() {
    BodyOverlay.component.show();
    const { orderId } = this.props;
    this.props.OrdersStore.getOrderDetails(orderId)
      .then(res => {
        BodyOverlay.component.hide();
        this.setState({ orderDetails: res.data, orderId });
      })
      .catch(err => {
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: ORDER_DETAILS_MESSAGES.ERROR_MESSAGE,
          timeout: 3000,
        });
        redirect("myorders");
      });
  }
  activateReturns(itemId, addressId, returnType) {
    this.setState({ isOpen: true, itemId, addressId, returnType });
    const returnProduct = this.state.orderDetails.consignments.find(
      (consignment) => { 
       return consignment.items.some((item) => {
         return item.itemId === itemId;
       });
      });
      
    const eventType = returnType && returnType.toLowerCase() === 'cancel' ? Event.GTMEvent.CANCEL_INITATED : Event.GTMEvent.RETURN_INITATED;

    GTM.pushWithEvent(
      {
        returnProduct,
        itemId
      },
      eventType
      );
  }

  closeModal() {
    this.setState({ isOpen: false, itemId: "", addressId: "" });
  }

  classNameSelector(className) {
    this.setState({
      childClassName: className,
    });
  }

  render() {
    const {
      orderDetails,
      isOpen,
      itemId,
      addressId,
      orderId = orderIdLocn,
      childClassName,
      returnType,
    } = this.state;
    return (
      <Fragment>
        {orderDetails &&
          orderDetails.orderId && (
            <Fragment>
              <GridContainer className="nw-orderdetailspage-body">
                <GridRow className="nw-orderdetailspage-title">
                  <GridColumn>
                    <i className="icomoon-payable-amount nw-orderdetailspage-icon" />
                    <div className="nw-orderdetailspage-titletext">
                      {ORDER_DETAILS.ORDER_SUMMARY.TITLE}
                    </div>
                  </GridColumn>
                </GridRow>
                <GridRow className="nw-orderdetailspage-summaryblock">
                  <GridColumn className="nwc-grid-col-md nw-orderdetailspage-summary-left">
                    <OrderSummary.component orderDetails={orderDetails} />
                  </GridColumn>
                  <GridColumn className="nwc-grid-col-md nw-orderdetailspage-pricingoverview">
                    <PricingOverview.component
                      pricingOverviewData={this.pricingDetails}
                      className="nw-orderdetailspage-overview"
                      title={ORDER_DETAILS.PRICE_OVERVIEW_TITLE}
                    />
                  </GridColumn>
                </GridRow>
                <ConsignmentWrapper.component
                  orderDetails={orderDetails}
                  returnClick={this.activateReturns}
                />
              </GridContainer>
            </Fragment>
          )}
        <Modal
          isOpen={isOpen}
          onClose={this.closeModal}
          className={`nw-returns ${childClassName}`}
        >
          <Returns.component
            orderId={orderId}
            itemId={itemId}
            deliveredAddressId={addressId}
            setClassName={this.classNameSelector}
            type={returnType}
            onSubmit={this.getOrderDetails}
            closeModal={this.closeModal}
          />
        </Modal>
        <BodyOverlay.component />
      </Fragment>
    );
  }
}

OrderDetails.wrappedComponent.propTypes = {
  orderId: PropTypes.string.isRequired,
  OrdersStore: PropTypes.shape({
    getOrderDetails: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("OrdersStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: OrderDetails.wrappedComponent,
  component: OrderDetails,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderDetailsComponents/index.js